import { useCallback } from "react";
import "./customitemrender.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlassChart, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDeleteTacheMutation, useUpdateTacheMutation } from "../../redux/api/cache";
import { useAppSelector } from "../../redux/store";

export default function CustomItemRender(props: any) {
    const produitsApprouves = props.item?.stats?.produitsApprouves;
    const produits = props.item.stats ? props.item.stats.produits : props.item.produits;
    let d_inv010 = useAppSelector(state => state.appState.d_inv010);
    const [deleteTache] = useDeleteTacheMutation();
    const [updateTache] = useUpdateTacheMutation();

    const handleAnalyserTache = useCallback(async (e: any) => {
        e.stopPropagation();
        if (d_inv010.canAdd && window.confirm("Ce processus analyse les produits selon les critères de la tâche et recrée entièrement la liste.  La progression sera réinitialisée.")) {
            await updateTache(props.item.id);
        }
    }, [updateTache, props, d_inv010.canAdd]);

    const handleDeleteTache = useCallback(async (e: any) => {
        e.stopPropagation();
        if (d_inv010.canModify && window.confirm("La liste de produits sera effacée et la progression perdue.")) {
            await deleteTache({ tacheId: props.item.id, prod_num: 0 });
            props.resetData(props.item.id);
        }
    }, [deleteTache, props, d_inv010.canModify]);

    const getStats = useCallback(() => {
        return (<>
            <span className="stats">{props.item.text}
            </span>
            <span className="stats k-text-center">{produits}
            </span>
            {produitsApprouves || produitsApprouves === 0 ?
                <span className="stats k-text-center">{`${Math.round((produitsApprouves / produits) * 100)}%`}</span> :
                props.item.automatique ? <span onClick={handleAnalyserTache} style={{ margin: '0 auto', cursor: `${d_inv010.canAdd ? "pointer" : "default"}` }} title={"Analyser"}>
                    <FontAwesomeIcon icon={props.item.automatique ? faMagnifyingGlassChart : faTrash} />
                </span> : <span onClick={handleDeleteTache} style={{ margin: '0 auto', cursor: `${d_inv010.canModify ? "pointer" : "default"}` }} title={"Supprimer"}>
                    <FontAwesomeIcon icon={props.item.automatique ? faMagnifyingGlassChart : faTrash} />
                </span>}

        </>);
    }, [props.item.text, produitsApprouves, produits, handleAnalyserTache, handleDeleteTache, props.item.automatique, d_inv010.canAdd, d_inv010.canModify]);

    const getWidth = useCallback(() => {
        if (props.item.four_cd || props.item.div_num) {
            return '200px';
        } else if (props.item.dept_cd) {
            return '176px';
        } else if (props.item.cat_cd) {
            if (props.itemHierarchicalIndex.split("_").length === 3)
                return '152px';
            else
                return '176px';
        } else {
            return '200px';
        }
    }, [props.item.cat_cd, props.item.dept_cd, props.item.four_cd, props.item.div_num, props.itemHierarchicalIndex])

    return <><div className="k-display-inline-grid" style={{ gridTemplateColumns: `${getWidth()} 50px 50px`, gridTemplateRows: 'auto' }}>{getStats()}</div></>
};